export const state = {
  categories: null,
  showImageViewer: false,
  imageViewer: {
    attachments: null,
    initialSlideNumber: null,
  },
};

export const getters = {
  categories: state => state.categories,
  showImageViewer: state => state.showImageViewer,
  imageViewerAttachments: state => state.imageViewer.attachments,
  imageViewerInitSlideNumber: state => state.imageViewer.initialSlideNumber,
};

export default {
  state,
  getters
};
